module.exports = __webpack_public_path__ + "img/studying_quality.95a524ae.png";